<script setup>
import { ref, watch } from 'vue';
import { usuarios } from 'cifra-api-js';
import itemsPublicosApi from '@/api/cifra/cuadernos/items_publicos';
import ModalSimple from '@/components/ModalSimple.vue';
import CarruselCalificacionesAlumno from './CarruselCalificacionesAlumno.vue';
import GraficoCalificacionesAlumno from './GraficoCalificacionesAlumno.vue';
import Spinner from '../../components/Spinner.vue';

const emits = defineEmits(['cargado', 'cerrado']);

const cargando = ref(false);
const showModal = ref(false);
const alumno = ref(null);
const asignatura = ref(null);
const evaluacion = ref(null);
const calificaciones = ref([]);
const medias = ref([]);

function loadData(data) {
  alumno.value = data.alumno;
  asignatura.value = data.asignatura;
  evaluacion.value = data.evaluacion;
  calificaciones.value = data.calificaciones;
  medias.value = data.medias;
  emits('cargado', data);
}

function reset() {
  alumno.value = null;
  asignatura.value = null;
  evaluacion.value = null;
  calificaciones.value = [];
  medias.value = [];
}

function show(idAlumno, idGrupo, idEvaluacion, idAsignatura, options) {
  cargando.value = true;
  showModal.value = true;

  itemsPublicosApi.alumno(
    idAlumno, idGrupo, idEvaluacion, idAsignatura, options,
  ).then((result) => {
    loadData(result.data);
    cargando.value = false;
  }).catch((error) => {
    cargando.value = false;
    console.error(error);
  });
}

watch(showModal, (nuevoValor) => {
  if (nuevoValor === false) {
    reset();
    emits('cerrado');
  }
});

defineExpose({ show });

</script>

<template>
  <teleport to="body">
    <ModalSimple
      v-model="showModal"
      tamano="lg"
    >
      <Spinner v-if="cargando" />
      <div v-if="!cargando && alumno">
        <div class="titulo-seccion m-t-none">
          {{ asignatura.nombre }}
          <small>{{ evaluacion.nombre }}</small>
        </div>
        <thumbnail-header
          :imagen="alumno.foto_url"
          :titulo="usuarios.fullname(alumno)"
          class="m-b"
        />
        <CarruselCalificacionesAlumno :calificaciones="calificaciones" />
        <GraficoCalificacionesAlumno
          :calificaciones="calificaciones"
          :medias="medias"
          class="m-t"
        />
      </div>
    </ModalSimple>
  </teleport>
</template>

<style lang="scss" scoped>
  .titulo-seccion small{
    display: block;
    font-size: 0.6em;
  }
</style>
